<template>
  <div>
    
    <!--FILTROS-->
    <b-card>
      <b-row class="mb-1">
        
        <!--PERÍODO-->
        <b-col lg="4" md="6">
          <b-form-group
            label="Periodo"
            label-size="sm"
            label-for="sortBySelect"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-select
                id="tipo"
                v-model="periodo"
                :options="periodos"
                text-field="text"
                value-field="value"
                style="height: 32px; max-width: 30%"
                @change="alterouPeriodo"
              >
              </b-form-select>
              <b-form-datepicker
                id="data_inicio"
                size="sm"
                v-model="filtros.data_inicio"
                :date-format-options="{
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                }"
                close-button
                weekday-header-format="narrow"
                offset="-25"
                dropdown
                hide-header
                label-close-button="Fechar"
                label-reset-button="Apagar_Data"
                labelHelp=""
                locale="pt-BR"
                placeholder="Data"
              />
              <b-form-datepicker
                id="data_final"
                size="sm"
                v-model="filtros.data_final"
                :date-format-options="{
                  day: 'numeric',
                  month: 'numeric',
                  year: 'numeric',
                }"
                close-button
                hide-header
                weekday-header-format="narrow"
                offset="-25"
                dropdown
                label-close-button="Fechar"
                label-reset-button="Apagar_Data"
                labelHelp=""
                locale="pt-BR"
                placeholder="Data"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        
        <!--STATUS-->
        <b-col lg="2" md="6">
          <b-form-group>
            <label label-for="categoria">Status:</label>
            <v-select
              id="categoria"
              class="select-size-sm"
              label="text"
              :clearable="false"
              :options="status"
              :reduce="status => status.value"
              v-model="filtros.status"
            />
          </b-form-group>
        </b-col>
        
        <!--EMAIL-->
        <b-col lg="2" md="3">
          <div>
            <b-form-group
              label="Email"
              label-size="sm"
              label-for="emailLogs"
              class="mb-0"
            >
              <b-input-group>
                <b-form-input
                  id="emailLogs"
                  size="sm"
                  v-model="filtros.email"
                />
                <b-input-group-append is-text size="sm">
                  <feather-icon style="cursor: pointer" icon="MailIcon" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
        </b-col>
        
        <!--ID COMPANY-->
        <b-col lg="2" md="2">
          <div>
            <b-form-group
              label="Empresa Id"
              label-size="sm"
              label-for="empresa_id"
              class="mb-0"
            >
              <b-form-input
                id="empresa_id"
                size="sm"
                v-model="filtros.id_company"
              />
            </b-form-group>
          </div>
        </b-col>
        
        <!--BUSCAR-->
        <b-col>
          
          <b-button
            variant="gradient-success"
            class="mt-2 mr-1"
            size="sm"
            @click="buscarLogs"
          >
            <feather-icon style="cursor: pointer; margin-left: 3px" icon="SearchIcon"/>
          
          </b-button>
          <b-button
            variant="gradient-primary"
            class="mt-2"
            size="sm"
            @click="limparFiltros"
            v-b-popover.hover.top="'Limpa Filtros'"
          >
            <feather-icon style="cursor: pointer; margin-left: 3px" icon="RefreshCcwIcon"/>
          </b-button>
        </b-col>
      
      </b-row>
    </b-card>
    <!--FIM FILTROS-->
  
  </div>


</template>

<script>

import {
  BCard,
  BCol,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  BButton,
  VBPopover
} from "bootstrap-vue";
import vSelect from "vue-select";
import moment from "moment/moment";

export default {
  components: {BCard, BFormGroup, BFormSelect, BFormDatepicker, BFormInput, BCol, BRow, BInputGroup, BInputGroupAppend, vSelect, BButton},
  directives: {
    'b-popover': VBPopover,
  },
  data() {
    return {
      status: [
        { value: "", text: 'Todos' },
        { value: "delivered", text: 'Enviado' },
        { value: "failed", text: 'Falha'},
      ],
      periodo: 1,
      periodos: [
        { value: 1, text: 'Hoje' },
        { value: 2, text: 'Esta Semana' },
        { value: 3, text: 'Este Mes' },
        { value: 4, text: '7 Dias Atras' },
        { value: 5, text: 'Outro Periodo' }
      ],
      filtros: {
        data_inicio: this.$getDate.hoje(),
        data_final: this.$getDate.hoje(),
        status: '',
        email: '',
        id_company: ''
      }
    };
  },
 
  methods: {
  
    alterouPeriodo() {
      const periodoConfigs = {
        0: () => {
          return { data_inicio: "", data_final: "" };
        },
        1: () => {
          return {
            data_inicio: this.$getDate.hoje(),
            data_final: this.$getDate.hoje()
          };
        },
        2: () => {
          // domingo desta semana até sábado desta semana
          return {
            data_inicio: moment().day(0).format("YYYY-MM-DD"),
            data_final: moment().day(6).format("YYYY-MM-DD")
          };
        },
        3: () => {
          return {
            data_inicio: moment().startOf("month").format("YYYY-MM-DD"),
            data_final: moment().endOf("month").format("YYYY-MM-DD")
          };
        },
        4: () => {
          return {
            data_inicio: this.$getDate.subDias(null, 7),
            data_final: this.$getDate.hoje()
          };
        }
      };
      
      // Verifica se o período existe no mapeamento
      if (periodoConfigs[this.periodo]) {
        const datas = periodoConfigs[this.periodo]();
        this.filtros.data_inicio = datas.data_inicio;
        this.filtros.data_final = datas.data_final;
      }
    },
    
    async buscarLogs() {
      await this.$store.commit("mensagensLogs/SET_FILTROS", this.filtros)
      await this.$store.dispatch("mensagensLogs/listaLogs")
    },
    
    limparFiltros() {
      
      this.periodo = 1;
      this.filtros = {
        data_inicio: this.$getDate.hoje(),
        data_final: this.$getDate.hoje(),
        status: '',
        email: '',
        id_company: ''
      }
      this.$store.commit("mensagensLogs/SET_FILTROS", this.filtros)
      
    }
    
  },
  
  
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
